<template>
  <el-dialog
    title="备注"
    :visible.sync="show"
    width="600px"
  >
    <div class="remark__content">
      <el-row>
        <el-col :span="24">卡号</el-col>
        <el-col :span="24">
          <el-input v-model="ids" disabled type="textarea" :rows="4" />
        </el-col>
        <el-col :span="24">备注</el-col>
        <el-col :span="24">
          <el-input v-model="remarks" type="textarea" :rows="4" />
        </el-col>
      </el-row>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="type" @click="show = false">取 消</el-button>
      <el-button size="type" type="primary" @click="onAddRemark">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name:"addRemark",
  props:{
    visible:{
      type:Boolean,
      default:false
    },
    ids:{
      type:String,
      default:''
    }
  },
  data(){
    return {
      show:false,
      remarks:'',
    }
  },
  watch:{
    visible:{
      handler(val){
        this.show = val;
        this.remarks = '';
      }
    },
    show:{
      handler(val){
        !val && this.$emit('update:visible',false);
      }
    }
  },
  methods:{
    // 备注
    async onAddRemark(){
      try{
        const { msg , code } = await this.$API.batchAddRemarkOfSim({
          simSegment:this.ids,
          remark:this.remarks
        });
        if(code === 200) throw { msg };
        this.$message({
          type:'success',
          message:'备注成功'
        });
        this.$emit('update:visible',false);
      }catch({ msg }){
        this.$message({
          type:'warning',
          message:msg
        });
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.remark__content{
  ::v-deep .el-col{
    margin-bottom: 10px;
  }
}
</style>
